/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 943e52fef3d3cc93d29d3ba9a63408c6 */

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type RemoveEventAttendanceInput = {
    clientMutationId?: string | null | undefined;
    eventId: string;
    userId?: string | null | undefined;
};
export type AttendEventButtonRemoveAttendanceMutationVariables = {
    input: RemoveEventAttendanceInput;
};
export type AttendEventButtonRemoveAttendanceMutationResponse = {
    readonly removeEventAttendance: {
        readonly event: {
            readonly " $fragmentRefs": FragmentRefs<"EventCard_event" | "EventScreenAttendanceCard_event" | "EventEditAttendeesList_event" | "AttendEventButton_event" | "EventItem_event" | "EventScreenMobile_event" | "EventScreenDesktop_event">;
        } | null;
    } | null;
};
export type AttendEventButtonRemoveAttendanceMutation = {
    readonly response: AttendEventButtonRemoveAttendanceMutationResponse;
    readonly variables: AttendEventButtonRemoveAttendanceMutationVariables;
};



/*
mutation AttendEventButtonRemoveAttendanceMutation(
  $input: RemoveEventAttendanceInput!
) {
  removeEventAttendance(input: $input) {
    event {
      ...EventCard_event
      ...EventScreenAttendanceCard_event
      ...EventEditAttendeesList_event
      ...AttendEventButton_event
      ...EventItem_event
      ...EventScreenMobile_event
      ...EventScreenDesktop_event
      id
    }
  }
}

fragment ActorItem_actor on Actor {
  __isActor: __typename
  __typename
  ... on User {
    ...UserItem_user_4qCZIv
  }
  ... on Guild {
    ...GuildItem_guild_U3Wpz
  }
}

fragment ActorItem_actor_3uhuib on Actor {
  __isActor: __typename
  __typename
  ... on User {
    ...UserItem_user_sLhLm
  }
  ... on Guild {
    ...GuildItem_guild_1Pu4so
  }
}

fragment AttendEventButton_event on Event {
  rowId
  prettyUrl
  hasExternalUrl
  hasVenue
  myAttendance {
    status
    userId
    id
  }
  owner {
    __typename
    ... on Guild {
      myMembership {
        id
      }
    }
    ... on User {
      id
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment EventCardAttendeesSection_event on Event {
  endAt
  attendingInPerson: eventAttendees(condition: {status: ATTENDING_IN_PERSON}, first: 5) {
    edges {
      node {
        user {
          primaryPhoto {
            id
          }
          ...UserPrimaryPhoto_user
          id
        }
        id
      }
      cursor
    }
    totalCount
  }
  attendingVirtually: eventAttendees(condition: {status: ATTENDING_VIRTUAL}, first: 5) {
    edges {
      node {
        user {
          primaryPhoto {
            id
          }
          ...UserPrimaryPhoto_user
          id
        }
        id
      }
      cursor
    }
    totalCount
  }
  waiting: eventAttendees(condition: {status: WAITING_IN_PERSON}, first: 5) {
    edges {
      node {
        user {
          ...UserPrimaryPhoto_user
          id
        }
        id
      }
      cursor
    }
    totalCount
  }
}

fragment EventCardPresentationsSection_event on Event {
  eventCardPresentations: presentations(first: 3, orderBy: [CREATED_AT_ASC, ID_ASC]) {
    edges {
      node {
        rowId
        presenterFirstName
        presenterLastName
        presenter {
          firstName
          lastName
          ...UserPrimaryPhoto_user
          id
        }
        id
      }
      cursor
    }
    totalCount
  }
}

fragment EventCard_event on Event {
  id
  rowId
  name
  slug
  prettyUrl
  startAt
  endAt
  timeZone
  myAttendance {
    id
  }
  visibility
  owner {
    __typename
    ...ActorItem_actor
    ... on User {
      isMe
    }
    ... on Guild {
      myMembership {
        membershipLevel
        id
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  eventCardHasPresentations: presentations(first: 1, orderBy: [CREATED_AT_ASC, ID_ASC]) {
    totalCount
  }
  coverPhoto {
    ...GraphQLImage_image
    id
  }
  ...EventItem_event
  ...AttendEventButton_event
  ...EventCardPresentationsSection_event
  ...EventCardAttendeesSection_event
}

fragment EventEditAttendeeItem_eventAttendee on EventAttendee {
  event {
    rowId
    id
  }
  user {
    rowId
    ...UserItem_user
    id
  }
  status
}

fragment EventEditAttendeesList_event on Event {
  eventAttendeesByStatus: eventAttendees(first: 20, orderBy: [STATUS_ASC]) {
    edges {
      node {
        id
        ...EventEditAttendeeItem_eventAttendee
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  id
}

fragment EventItem_event on Event {
  id
  prettyUrl
  startAt
  endAt
  name
  description
  owner {
    __typename
    ... on Guild {
      myMembership {
        membershipLevel
        id
      }
    }
    ... on User {
      isMe
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  ...AttendEventButton_event
  ...EventCardPresentationsSection_event
  ...EventCardAttendeesSection_event
  ...EventVisibilityCrumb_event
}

fragment EventScreenAttendanceCardAttendanceGrid_eventAttendees on EventAttendeesConnection {
  edges {
    node {
      id
      status
      user {
        slugId
        firstName
        lastName
        ...UserPrimaryPhoto_user
        id
      }
    }
    cursor
  }
}

fragment EventScreenAttendanceCardAttendingInPersonSection_event on Event {
  attendeeLimit
  inPersonAttendees: eventAttendees(first: 32, condition: {status: ATTENDING_IN_PERSON}) {
    edges {
      cursor
      node {
        __typename
        id
      }
    }
    totalCount
    ...EventScreenAttendanceCardAttendanceGrid_eventAttendees
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  id
}

fragment EventScreenAttendanceCardAttendingVirtualSection_event on Event {
  attendeeLimit
  virtualAttendees: eventAttendees(first: 32, condition: {status: ATTENDING_VIRTUAL}) {
    edges {
      cursor
      node {
        __typename
        id
      }
    }
    totalCount
    ...EventScreenAttendanceCardAttendanceGrid_eventAttendees
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  id
}

fragment EventScreenAttendanceCardNotAttendingSection_event on Event {
  owner {
    __typename
    ... on User {
      isMe
    }
    ... on Guild {
      myMembership {
        membershipLevel
        id
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  notAttendingAttendees: eventAttendees(first: 16, condition: {status: NOT_ATTENDING}) {
    edges {
      cursor
      node {
        __typename
        id
      }
    }
    ...EventScreenAttendanceCardAttendanceGrid_eventAttendees
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  id
}

fragment EventScreenAttendanceCardWaitingSection_event on Event {
  waitingAttendees: eventAttendees(first: 32, condition: {status: WAITING_IN_PERSON}) {
    edges {
      cursor
      node {
        __typename
        id
      }
    }
    totalCount
    ...EventScreenAttendanceCardAttendanceGrid_eventAttendees
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  id
}

fragment EventScreenAttendanceCard_event on Event {
  eventAttendees {
    totalCount
  }
  ...EventScreenAttendanceCardAttendingInPersonSection_event
  ...EventScreenAttendanceCardAttendingVirtualSection_event
  ...EventScreenAttendanceCardWaitingSection_event
  ...EventScreenAttendanceCardNotAttendingSection_event
}

fragment EventScreenDescriptionCard_event on Event {
  name
  description
  id
  hasExternalUrl
  hasVenue
  visibility
  owner {
    __typename
    ... on Guild {
      myMembership {
        membershipLevel
        id
      }
    }
    ... on User {
      isMe
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  ...EventVisibilityCrumb_event
}

fragment EventScreenDesktop_event on Event {
  hasVenue
  hasExternalUrl
  externalUrl
  myAttendance {
    status
    id
  }
  ...EventCard_event
  ...EventScreenPresentationsCard_event
  ...EventScreenAttendanceCard_event
  ...EventScreenJoinCard_event
  ...EventScreenDescriptionCard_event
  ...EventScreenHasAttendanceInformationCard_event
  owner {
    __typename
    ... on User {
      firstName
      lastName
    }
    ... on Guild {
      name
    }
    ...ActorItem_actor_3uhuib
    ... on Node {
      __isNode: __typename
      id
    }
  }
  venue {
    ...EventScreenVenueCard_venue
    id
  }
}

fragment EventScreenHasAttendanceInformationCard_event on Event {
  hasExternalUrl
  hasVenue
}

fragment EventScreenJoinCard_event on Event {
  externalUrl
}

fragment EventScreenMobile_event on Event {
  hasVenue
  hasExternalUrl
  externalUrl
  myAttendance {
    status
    id
  }
  ...EventCard_event
  owner {
    __typename
    ...ActorItem_actor
    ... on Node {
      __isNode: __typename
      id
    }
  }
  ...EventScreenPresentationsCard_event
  ...EventScreenAttendanceCard_event
  ...EventScreenJoinCard_event
  ...EventScreenDescriptionCard_event
  ...EventScreenHasAttendanceInformationCard_event
  venue {
    id
    ...EventScreenVenueCard_venue
  }
}

fragment EventScreenPresentationsCard_event on Event {
  prettyUrl
  owner {
    __typename
    ... on User {
      isMe
    }
    ... on Guild {
      myMembership {
        membershipLevel
        id
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  presentations(first: 6, orderBy: [CREATED_AT_ASC, ID_ASC]) {
    edges {
      node {
        id
        presenter {
          id
        }
        ...PresentationItem_presentation
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  id
}

fragment EventScreenVenueCard_address on Address {
  addressLine1
  addressLine2
  city
  stateProvinceRegionCode
  zipPostalCode
  countryCode
}

fragment EventScreenVenueCard_venue on Venue {
  name
  entryInstructions
  address {
    ...EventScreenVenueCard_address
    id
  }
}

fragment EventVisibilityCrumb_event on Event {
  hasExternalUrl
  hasVenue
  visibility
}

fragment GraphQLImage_image on Image {
  url
}

fragment GuildItem_guild_1Pu4so on Guild {
  slugId
  name
  ...GuildMembershipStatus_guild_1Pu4so
  ...GuildPrimaryPhoto_guild
}

fragment GuildItem_guild_U3Wpz on Guild {
  slugId
  name
  ...GuildMembershipStatus_guild_U3Wpz
  ...GuildPrimaryPhoto_guild
}

fragment GuildMembershipStatus_guild_1Pu4so on Guild {
  networkMembers {
    totalCount
  }
}

fragment GuildMembershipStatus_guild_U3Wpz on Guild {
  myMembership {
    membershipLevel
    id
  }
  networkMembers {
    totalCount
  }
}

fragment GuildPrimaryPhoto_guild on Guild {
  type
  primaryPhoto {
    ...GraphQLImage_image
    id
  }
}

fragment PresentationItem_presentation on Presentation {
  rowId
  description
  title
  presenterFirstName
  presenterLastName
  prettyUrl
  presenter {
    slugId
    firstName
    lastName
    ...UserPrimaryPhoto_user
    id
  }
}

fragment UserDefaultPhoto_user on User {
  rowId
  emailMd5
}

fragment UserFollowingStatus_user_4qCZIv on User {
  followerCount
  isMe
  isFollowing
}

fragment UserFollowingStatus_user_sLhLm on User {
  followerCount
}

fragment UserItem_user on User {
  slugId
  firstName
  lastName
  followerCount
  ...UserPrimaryPhoto_user
  ...UserFollowingStatus_user_4qCZIv
}

fragment UserItem_user_4qCZIv on User {
  slugId
  firstName
  lastName
  followerCount
  ...UserPrimaryPhoto_user
  ...UserFollowingStatus_user_4qCZIv
}

fragment UserItem_user_sLhLm on User {
  slugId
  firstName
  lastName
  followerCount
  ...UserPrimaryPhoto_user
  ...UserFollowingStatus_user_sLhLm
}

fragment UserPrimaryPhoto_user on User {
  ...UserDefaultPhoto_user
  primaryPhoto {
    ...GraphQLImage_image
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prettyUrl",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "followerCount",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailMd5",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v14 = [
  (v13/*: any*/),
  (v2/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryPhoto",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMe",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFollowing",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v19 = [
  (v18/*: any*/)
],
v20 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": [
    "CREATED_AT_ASC",
    "ID_ASC"
  ]
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "presenterFirstName",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "presenterLastName",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v25 = {
  "kind": "Literal",
  "name": "condition",
  "value": {
    "status": "ATTENDING_IN_PERSON"
  }
},
v26 = {
  "kind": "Literal",
  "name": "first",
  "value": 5
},
v27 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "EventAttendeesEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EventAttendee",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "primaryPhoto",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/),
              (v12/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      (v24/*: any*/)
    ],
    "storageKey": null
  },
  (v18/*: any*/)
],
v28 = {
  "kind": "Literal",
  "name": "condition",
  "value": {
    "status": "ATTENDING_VIRTUAL"
  }
},
v29 = {
  "kind": "Literal",
  "name": "condition",
  "value": {
    "status": "WAITING_IN_PERSON"
  }
},
v30 = {
  "kind": "Literal",
  "name": "first",
  "value": 32
},
v31 = [
  (v25/*: any*/),
  (v30/*: any*/)
],
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "EventAttendeesEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    (v24/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "EventAttendee",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v7/*: any*/),
        (v2/*: any*/),
        (v6/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/),
            (v3/*: any*/),
            (v12/*: any*/),
            (v15/*: any*/),
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v34 = [
  (v32/*: any*/),
  (v18/*: any*/),
  (v33/*: any*/)
],
v35 = [
  "condition"
],
v36 = [
  (v28/*: any*/),
  (v30/*: any*/)
],
v37 = [
  (v29/*: any*/),
  (v30/*: any*/)
],
v38 = [
  {
    "kind": "Literal",
    "name": "condition",
    "value": {
      "status": "NOT_ATTENDING"
    }
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 16
  }
],
v39 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": [
      "STATUS_ASC"
    ]
  }
],
v40 = [
  "orderBy"
],
v41 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 6
  },
  (v20/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AttendEventButtonRemoveAttendanceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RemoveEventAttendancePayload",
        "kind": "LinkedField",
        "name": "removeEventAttendance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventCard_event"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventScreenAttendanceCard_event"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventEditAttendeesList_event"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AttendEventButton_event"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventItem_event"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventScreenMobile_event"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventScreenDesktop_event"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AttendEventButtonRemoveAttendanceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RemoveEventAttendancePayload",
        "kind": "LinkedField",
        "name": "removeEventAttendance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slug",
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeZone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EventAttendee",
                "kind": "LinkedField",
                "name": "myAttendance",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "visibility",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isActor"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v3/*: any*/),
                      (v12/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v2/*: any*/)
                    ],
                    "type": "User",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GuildMembership",
                        "kind": "LinkedField",
                        "name": "myMembership",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "membershipLevel",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UsersConnection",
                        "kind": "LinkedField",
                        "name": "networkMembers",
                        "plural": false,
                        "selections": (v19/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      (v15/*: any*/)
                    ],
                    "type": "Guild",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "eventCardHasPresentations",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  },
                  (v20/*: any*/)
                ],
                "concreteType": "PresentationsConnection",
                "kind": "LinkedField",
                "name": "presentations",
                "plural": false,
                "selections": (v19/*: any*/),
                "storageKey": "presentations(first:1,orderBy:[\"CREATED_AT_ASC\",\"ID_ASC\"])"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "coverPhoto",
                "plural": false,
                "selections": (v14/*: any*/),
                "storageKey": null
              },
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasExternalUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasVenue",
                "storageKey": null
              },
              {
                "alias": "eventCardPresentations",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 3
                  },
                  (v20/*: any*/)
                ],
                "concreteType": "PresentationsConnection",
                "kind": "LinkedField",
                "name": "presentations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PresentationsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Presentation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "presenter",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v3/*: any*/),
                              (v12/*: any*/),
                              (v15/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v18/*: any*/)
                ],
                "storageKey": "presentations(first:3,orderBy:[\"CREATED_AT_ASC\",\"ID_ASC\"])"
              },
              {
                "alias": "attendingInPerson",
                "args": [
                  (v25/*: any*/),
                  (v26/*: any*/)
                ],
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendees",
                "plural": false,
                "selections": (v27/*: any*/),
                "storageKey": "eventAttendees(condition:{\"status\":\"ATTENDING_IN_PERSON\"},first:5)"
              },
              {
                "alias": "attendingVirtually",
                "args": [
                  (v28/*: any*/),
                  (v26/*: any*/)
                ],
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendees",
                "plural": false,
                "selections": (v27/*: any*/),
                "storageKey": "eventAttendees(condition:{\"status\":\"ATTENDING_VIRTUAL\"},first:5)"
              },
              {
                "alias": "waiting",
                "args": [
                  (v29/*: any*/),
                  (v26/*: any*/)
                ],
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendees",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventAttendeesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventAttendee",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v12/*: any*/),
                              (v15/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v18/*: any*/)
                ],
                "storageKey": "eventAttendees(condition:{\"status\":\"WAITING_IN_PERSON\"},first:5)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendees",
                "plural": false,
                "selections": (v19/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "attendeeLimit",
                "storageKey": null
              },
              {
                "alias": "inPersonAttendees",
                "args": (v31/*: any*/),
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendees",
                "plural": false,
                "selections": (v34/*: any*/),
                "storageKey": "eventAttendees(condition:{\"status\":\"ATTENDING_IN_PERSON\"},first:32)"
              },
              {
                "alias": "inPersonAttendees",
                "args": (v31/*: any*/),
                "filters": (v35/*: any*/),
                "handle": "connection",
                "key": "EventScreenAttendanceCardAttendingInPersonSection_event_inPersonAttendees",
                "kind": "LinkedHandle",
                "name": "eventAttendees"
              },
              {
                "alias": "virtualAttendees",
                "args": (v36/*: any*/),
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendees",
                "plural": false,
                "selections": (v34/*: any*/),
                "storageKey": "eventAttendees(condition:{\"status\":\"ATTENDING_VIRTUAL\"},first:32)"
              },
              {
                "alias": "virtualAttendees",
                "args": (v36/*: any*/),
                "filters": (v35/*: any*/),
                "handle": "connection",
                "key": "EventScreenAttendanceCardAttendingVirtualSection_event_virtualAttendees",
                "kind": "LinkedHandle",
                "name": "eventAttendees"
              },
              {
                "alias": "waitingAttendees",
                "args": (v37/*: any*/),
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendees",
                "plural": false,
                "selections": (v34/*: any*/),
                "storageKey": "eventAttendees(condition:{\"status\":\"WAITING_IN_PERSON\"},first:32)"
              },
              {
                "alias": "waitingAttendees",
                "args": (v37/*: any*/),
                "filters": (v35/*: any*/),
                "handle": "connection",
                "key": "EventScreenAttendanceCardWaitingSection_event_waitingAttendees",
                "kind": "LinkedHandle",
                "name": "eventAttendees"
              },
              {
                "alias": "notAttendingAttendees",
                "args": (v38/*: any*/),
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendees",
                "plural": false,
                "selections": [
                  (v32/*: any*/),
                  (v33/*: any*/)
                ],
                "storageKey": "eventAttendees(condition:{\"status\":\"NOT_ATTENDING\"},first:16)"
              },
              {
                "alias": "notAttendingAttendees",
                "args": (v38/*: any*/),
                "filters": (v35/*: any*/),
                "handle": "connection",
                "key": "EventScreenAttendanceCardNotAttendingSection_event_notAttendingAttendees",
                "kind": "LinkedHandle",
                "name": "eventAttendees"
              },
              {
                "alias": "eventAttendeesByStatus",
                "args": (v39/*: any*/),
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendees",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventAttendeesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventAttendee",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Event",
                            "kind": "LinkedField",
                            "name": "event",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v8/*: any*/),
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/),
                              (v12/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v33/*: any*/)
                ],
                "storageKey": "eventAttendees(first:20,orderBy:[\"STATUS_ASC\"])"
              },
              {
                "alias": "eventAttendeesByStatus",
                "args": (v39/*: any*/),
                "filters": (v40/*: any*/),
                "handle": "connection",
                "key": "EventEditAttendeesList_event_eventAttendeesByStatus",
                "kind": "LinkedHandle",
                "name": "eventAttendees"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v41/*: any*/),
                "concreteType": "PresentationsConnection",
                "kind": "LinkedField",
                "name": "presentations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PresentationsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Presentation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "presenter",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v8/*: any*/),
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v3/*: any*/),
                              (v12/*: any*/),
                              (v15/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          (v21/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v5/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v33/*: any*/)
                ],
                "storageKey": "presentations(first:6,orderBy:[\"CREATED_AT_ASC\",\"ID_ASC\"])"
              },
              {
                "alias": null,
                "args": (v41/*: any*/),
                "filters": (v40/*: any*/),
                "handle": "connection",
                "key": "EventScreenPresentationsCard_event_presentations",
                "kind": "LinkedHandle",
                "name": "presentations"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Venue",
                "kind": "LinkedField",
                "name": "venue",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "entryInstructions",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "address",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "addressLine1",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "addressLine2",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "city",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "stateProvinceRegionCode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "zipPostalCode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "countryCode",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "381e614742cdd1f2ab6b0da9feec28b9f9d74074c73eff34a9cfbe4b52da9db1",
    "metadata": {},
    "name": "AttendEventButtonRemoveAttendanceMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
(node as any).hash = '7c56ce9f3dfb6dd8614fa0f6b0867d97';
export default node;
